module.exports = __webpack_public_path__ + "img/2019homepark-6.e1f77c8d.jpeg";